import { Button } from "@fluentui/react-components";
import { ROUTES } from "library/routes";
import { openLinkInNewTab } from "library/utils";
import { useGetConsentLink } from "pages/ProfilePage/components/EmployeeForm/hooks/useGetConsentLink";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { logout } from "service/auth";
import styled from "styled-components";

import { useHasGivenConsent } from "hooks/useHasGivenConsent";

import { ReactComponent as SignOutIcon } from "assets/icons/signOutIcon.svg";
import { ReactComponent as SupportIcon } from "assets/icons/supportIcon.svg";

type Props = {
  togglePanel?: () => void;
};
export const NavFooterContent = ({ togglePanel }: Props) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const consentLink = useGetConsentLink();
  const hasGivenConsent = useHasGivenConsent();

  const showEditProfileBtn = !!togglePanel;

  return (
    <>
      {showEditProfileBtn && (
        <StyledButton
          disabled={!hasGivenConsent}
          onClick={() => {
            navigate(ROUTES.PROFILE);
            if (togglePanel) {
              togglePanel();
            }
          }}
          appearance="transparent"
        >
          {t("hbh.editProfile.label")}
        </StyledButton>
      )}
      <StyledButton
        disabled={!hasGivenConsent}
        onClick={() => {
          navigate(ROUTES.EMPLOYER);
          if (togglePanel) {
            togglePanel();
          }
        }}
        appearance="transparent"
      >
        {t("hbh.employerDocuments.label")}
      </StyledButton>
      <StyledButton
        onClick={() => {
          openLinkInNewTab(consentLink);
        }}
        appearance="transparent"
      >
        {t("hbh.privacyNotice.label")}
      </StyledButton>
      <a href="mailto:support@greco.services">
        <StyledButton
          iconPosition="after"
          icon={<SupportIcon />}
          appearance="transparent"
        >
          {t("hbh.support.label")}
        </StyledButton>
      </a>
      <StyledButton
        onClick={() => logout()}
        appearance="transparent"
        iconPosition="after"
        icon={<SignOutIcon />}
      >
        {t("header.SignOut")}
      </StyledButton>
    </>
  );
};

const StyledButton = styled(Button)`
  justify-content: flex-start;
  padding-left: 0 !important;
`;
